<template>
    <div class="projectBody">
        <div class="width_total_100 headerBg projectTopBg animateContent projectAnimate1">
            <div class="w_container">
                <div class="commonTop">
                    <OmpLink></OmpLink>
                </div>
                <div class="bannerPart">
                    <div class="line">
                        <img src="https://escloud.digiwincloud.com/static/zh-TW/img/LINE.png" alt="line"/>
                        <p>掃描二維碼添加LINE</p>
                    </div>
                    <div style="padding-left: 110px;">
                        <div>深度挖掘數據潛在價值</div>
                        <p>一鍵快速產生視覺化圖表</p>
                    </div>
                    <FreeTryButton @getFreeTryVisible="getVisible"></FreeTryButton>
                </div>
            </div>
        </div>
        <div class="width_total_100 animateContent projectAnimate2" style="margin-top:-650px;">
            <div class="w_container">
                <div class="instruction">
                    <div class="instruTitle">
                        <div>功能亮點</div>
                        <p>Functional highlights</p>
                    </div>
                    <div class="proHightLights">
                        <ul>
                            <li>
                                <img src="../assets/img/projectFea_01.png" />
                                <p>資料異動自動上傳，及時最新</p>
                            </li>
                            <li>
                                <img src="../assets/img/projectFea_02.png" />
                                <p>支持圖內篩選，多角度查看</p>
                            </li>
                            <li>
                                <img src="../assets/img/projectFea_03.png" />
                                <p>串連ERP報表，免對帳麻煩</p>
                            </li>
                            <li>
                                <img src="../assets/img/projectFea_04.png" />
                                <p>支持多資料來源(EXCEL、SQL)</p>
                            </li>
                            <li>
                                <img src="../assets/img/projectFea_05.png" />
                                <p>不需具語意層撰寫能力，簡單</p>
                            </li>
                            <li>
                                <img src="../assets/img/projectFea_06.png" />
                                <p>使用權限靈活控管，資訊安全</p>
                            </li>
                            <li>
                                <img src="../assets/img/projectFea_07.png" />
                                <p>一鍵快速生成酷炫圖表，專業</p>
                            </li>
                            <li>
                                <img src="../assets/img/projectFea_08.png" />
                                <p>多報表關聯，數據無需匯入匯出</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="width_total_100">
            <div class="w_container">
                <div class="prjCharacters">
                    <div class="instruTitle proMakeTitle">
                        <div>產品特色</div>
                        <p>Product Characteristics</p>
                    </div>
                    <div class="proCharacterCon">
                        <el-carousel trigger="click" :autoplay="false" height="610px">
                            <el-carousel-item>
                                <div class="prjCharaSlideCon clearfix">
                                    <img src="https://escloud.digiwincloud.com/static/zh-TW/img/projectFea_09.gif" />
                                    <div class="prjCharaSlideCon_font">
                                        <div>關聯數據  自動更新</div>
                                        <p>系統連接ERP報表，圖表隨原始資料按時更新，不需人工修改，能提升資料處理效率，減少人工成本。</p>
                                    </div>
                                </div>
                            </el-carousel-item>
                            <el-carousel-item>
                                <div class="prjCharaSlideCon clearfix">
                                    <img src="https://escloud.digiwincloud.com/static/zh-TW/img/projectFea_10.gif" />
                                    <div class="prjCharaSlideCon_font">
                                        <div>異常數據  智能預警</div>
                                        <p>事先設定數據警示線，異常情況一旦發生，將第一時間發送訊息通知，降低企業犯錯成本。</p>
                                    </div>
                                </div>
                            </el-carousel-item>
                            <el-carousel-item>
                                <div class="prjCharaSlideCon clearfix">
                                    <img src="https://escloud.digiwincloud.com/static/zh-TW/img/projectFea_11.gif" />
                                    <div class="prjCharaSlideCon_font">
                                        <div>明細查詢  快速定位</div>
                                        <p>提供多維度的數據圖表呈現，支援異常數據的明細查詢，可快速發現問題源頭，制定應對方案。</p>
                                    </div>
                                </div>
                            </el-carousel-item>
                            <el-carousel-item>
                                <div class="prjCharaSlideCon clearfix">
                                    <img src="https://escloud.digiwincloud.com/static/zh-TW/img/projectFea_12.gif" />
                                    <div class="prjCharaSlideCon_font">
                                        <div>操作簡單  拖曳完成</div>
                                        <p>簡單推曳即可產生數據圖表，不需求助專業人員或資訊單位，不會SQL、EXCEL照樣搞定數據處理。</p>
                                    </div>
                                </div>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                </div>
            </div>
        </div>
        <div class="width_total_100 animateContent projectAnimate3">
            <div class="w_container">
                <div class="projectTec">
                    <div class="instruTitle proMakeTitle projectTecTitle">
                        <div>技術可靠  保障安全</div>
                        <p>Product Pricing</p>
                    </div>
                    <div class="projectTecCon">
                        <ul class="clearfix">
                            <li class="projTeLi1">
                                <em>架構</em>
                                <div class="projectTecConPer">
                                    <p>建構在微軟雲平台Microsoft Azure的混合雲架構</p>
                                    <div class="proLine"></div>
                                    <p>數據服務器可部署在企業內部主機</p>
                                    <div class="proLine"></div>
                                    <p>應用服務器可選擇上雲或本地部署</p>
                                    <div class="proLine"></div>
                                    <p>支援大規模全域服務所需要的雲端基礎架構</p>
                                </div>
                            </li>
                            <li class="projTeLi2">
                                <em>數據</em>
                                <div class="projectTecConPer">
                                    <p>採用進階加密標準AES 128bits進行檔案加密。</p>
                                    <div class="proLine"></div>
                                    <p>精細化使用者權限控管，使用行為可全程追蹤，防止洩密。</p>
                                    <div class="proLine"></div>
                                    <p>利用憑證綁定方式，防止中間人攻擊傳輸中資料。</p>
                                    <div class="proLine"></div>
                                    <p>採取高可用（HA）措施，可自動、定時備份，杜絕資料遺失風險。</p>
                                </div>
                            </li>
                            <li class="projTeLi3">
                                <em>應用</em>
                                <div class="projectTecConPer">
                                    <p>加密通道與雲端機密連接</p>
                                    <div class="proLine"></div>
                                    <p>企業身份確認及權限控管</p>
                                    <div class="proLine"></div>
                                    <p>監控帳號的登入密碼及時間，限制非法登入嘗試</p>
                                    <div class="proLine"></div>
                                    <p>採用https協定代替http協定，SSL/TLS加密傳輸資訊，防止篡改/竊聽/截取</p>
                                </div>
                            </li>
                            <li class="projTeLi4">
                                <em>平台</em>
                                <div class="projectTecConPer">
                                    <p>採用符合業界通訊協定的OAuth 2進行雲端平台身份驗證及授權</p>
                                    <div class="proLine"></div>
                                    <p>符合實體安全性和可用性的行業標準，如 ISO 27001等</p>
                                    <div class="proLine"></div>
                                    <p>服務可用性>99.99%</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="width_total_100 proBottomBg animateContent projectAnimate4">
            <div class="w_container">
                <div class="projectChange">
                    <div class="instruTitle quickTitle animateTitle">
                        <div>使用Tip Biu BI，可以為您帶來哪些改變?</div>
                        <p>What changes can you make by using graphical reports?</p>
                    </div>
                    <div class="projectChangeCon">
                        <div class="proChangePer">
                            <div class="proChangePerCon">
                                <img src="https://escloud.digiwincloud.com/static/zh-TW/img/project_before.png" />
                                <ul>
                                    <li>1. 數據圖表製作過程複雜、重覆、漫長，無法即時更新變動數據，影響決策效率。</li>
                                    <li>2. 報表資料來源大量且繁雜，無法直接抓取關鍵數據，以及時發現風險問題。</li>
                                    <li>3. 一般使用Excel製作圖表，報表的及時性、美觀度、專業性、安全性等方面較差。</li>
                                    <li>4. 跨部門開會無重點、無結果，管理者難以現場展現有說服力的數據圖表供決策人員參考，一個項目難以多方合作推進。</li>
                                </ul>
                            </div>
                        </div>
                        <div class="proChangePer">
                            <div class="proChangePerCon">
                                <img src="https://escloud.digiwincloud.com/static/zh-TW/img/project_now.png" />
                                <ul>
                                    <li>1. 快速、自動抓取ERP系統數據，按時更新數據資料，避免人工重覆稽核。</li>
                                    <li>2. 多維度、圖形化呈現數據圖表，滿足閱讀者不同角度的數據需求，輔助商業決策。</li>
                                    <li>3. 按使用者設定部門數據瀏覽及編輯權限，跨部門合作提升企業整體營運效率。</li>
                                    <li>4. 一鍵產生數據圖表，根據使用者權限可隨時隨地查閱，跨部合作更容易!</li>
                                </ul>
                            </div>
                        </div>
                        <div class="projFreeTry">
                            <FreeTryButton @getFreeTryVisible="getVisible"></FreeTryButton>
                        </div>
                        <div class="clear"></div>
                        <div style="margin-top:130px;">
                            <Footer></Footer>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Control></Control>
        <FreeTry :visible.sync="freeTryVisible"></FreeTry>
    </div>
</template>
<script>
    import "@/assets/css/w-style.css"

    import OmpLink from "@/components/common/OmpLink.vue"
    import Control from "@/components/common/Control.vue"
    import Footer from "@/components/common/Footer.vue"
    import FreeTryButton from "@/components/common/FreeTryButton.vue"
    import FreeTry from "@/components/common/FreeTry.vue"

  export default {
    components: {
        OmpLink,
        Control,
        Footer,
        FreeTryButton,
        FreeTry
    },
    name: 'Project',
    data() {
      return {
        freeTryVisible: false
      }
    },
    created () {
        this.$http.post('/backend/web/record', {
            pageName: 'Project',
            contentName : ''
        }, {headers: { "Content-Type": "application/json" }})
        .then(function (response) {
            if(response.status == 200){
                console.log("success");
            }
        })
        .catch(function (error) {
            console.log(error);
        });
    },
    mounted() {
        this.projectTopAnimate() // 顶部动画
        this.projectScrollAnimate() // 滚动动画
    },
    methods: {
        projectTopAnimate() {
            var projectAnimate_show1=1,projectAnimate_show2=1
            $(".projectBody").children(".animateContent").each(function() {
            if($(this).hasClass("projectAnimate1") &&  parseInt(projectAnimate_show1)){
                projectAnimate_show1 = 0;
                $(this).find(".bannerPart").delay(800).addClass('animated fadeInUp');
            }else if($(this).hasClass("projectAnimate2") &&  parseInt(projectAnimate_show2)){
                projectAnimate_show2 = 0;
                $(this).find(".proHightLights ul li").delay(800).addClass('flipInX animated hinge3');
                $(this).find(".proHightLights ul li").stop().animate({"opacity":"1"},400);
            } 
	     });
        },
        projectScrollAnimate() {
            $(window).scroll(function(){
                var projectAnimate_show3=1,projectAnimate_show4=1;
                var scrollTop = window.pageYOffset||document.documentElement.scrollTop||document.body.scrollTop|| 0;
                $(".projectBody").children(".animateContent").each(function() {
                    var srollh = $(this).offset().top-$(window).height()+$(this).height()/3;
                    if((scrollTop > srollh)){
                        if($(this).hasClass("projectAnimate3") &&  parseInt(projectAnimate_show3)){
                            projectAnimate_show3 = 0;
                            $(this).find(".projTeLi1").stop().animate({"opacity":"1"},400);
                            $(this).find(".projTeLi2").stop().delay(300).animate({"opacity":"1"},400);
                            $(this).find(".projTeLi3").stop().delay(600).animate({"opacity":"1"},400);
                            $(this).find(".projTeLi4").stop().delay(900).animate({"opacity":"1"},400);
                        } else if($(this).hasClass("projectAnimate4") &&  parseInt(projectAnimate_show4)){
                            projectAnimate_show4 = 0;
                            $(this).find(".animateTitle").delay(800).addClass('animated bounceIn');
                            $(this).find(".proChangePer:nth-child(1)").delay(800).addClass('animated bounceIn');
                            $(this).find(".proChangePer:nth-child(2)").delay(800).addClass('animated bounceIn');
                            $(this).find(".projFreeTry").delay(800).addClass('animated bounceIn');
                            $(this).find(".proChangePer").stop().animate({"opacity":"1"},400);
                            $(this).find(".animateTitle").stop().animate({"opacity":"1"},400);
                            $(this).find(".projFreeTry").stop().animate({"opacity":"1"},400);
                        }	
                    }
                });
            });
        },
        getVisible(visible) {
            this.freeTryVisible = visible
        }
    }
  }
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Project.vue